import { features } from '@kdcloudjs/table';
function useColumnResize(pipeline, columnResize) {
  if (columnResize) {
    pipeline.use(features.columnResize(columnResize === true ? {} : columnResize));
  }
}
export default useColumnResize;